import axios from 'axios';
import * as loaderActions from '@common/store/loader/loader.actionsType';
import localUtils from '@common/helpers/localStorage.utils';
import qs from 'qs';

const delay = (ms) => new Promise((res) => setTimeout(res, ms));
const Timeout = 12000000;

let isRedirectingToLogin = null;
const redirectToLogin = async () => {
  if (isRedirectingToLogin == null) {
    isRedirectingToLogin = true;

    _showError('Autenticação necessária');
    await delay(2000);

    localUtils.destroy();

    const returnRoute = {
      originUrl: window.location.href.split('#')[0],
      returnUrl: window.location.hash.replace('#', ''),
      reason: 'NotLoggedIn',
    };

    window.location.href = system_routes.Common.Url + '/#/login?' + $.param(returnRoute);
  }
};

let isRefreshing = false;

let refreshToken = (http, session) => {
  isRefreshing = true;
  isRedirectingToLogin = null;

  let refreshToken = session.refreshToken;
  let authUrl = `${window.api_routes.smarAPD_Authorization_Domain}/oauth/token`;

  var customHeaders = {
    Accept: 'application/json; version=2.0',
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    Authorization: 'Basic V2ViU21hckFQRDpXZWJTbWFyQVBE',
  };
  let refreshData = {
    refresh_token: refreshToken,
    grant_type: 'refresh_token',
  };

  http.post(authUrl, qs.stringify(refreshData), { headers: customHeaders }).then((response) => {
    localUtils.setItem('REFRESH_INFO', new Date().getTime() + parseInt(window.appConfig.tokenRefreshInterval));
    var sessionLocal = localUtils.getItem('SESSION_INFO_STORAGE_KEY');
    sessionLocal.accessToken = response.data.access_token;
    sessionLocal.refreshToken = response.data.refresh_token;
    localUtils.setItem('SESSION_INFO_STORAGE_KEY', sessionLocal);
    isRefreshing = false;
  });
};

const getHttp = (store, baseUrl, timeout = 12000000, isShowException = true) => {
  let host = window.location.host;
  let protocol = window.location.protocol;

  const http = axios.create({
    baseURL: baseUrl,
    timeout: timeout,
  });

  let requestAdded = 0;
  let requestCompleted = 0;
  let addRequest = () => {
    requestAdded++;
    if (store)
      store.dispatch({
        type: loaderActions.LOADER_SHOW,
      });
  };
  let subRequest = () => {
    requestCompleted++;
    if (store && requestAdded == requestCompleted)
      store.dispatch({
        type: loaderActions.LOADER_HIDE,
      });
  };

  http.interceptors.request.use(
    function (config) {
      let session = localUtils.getSession();

      if (session) {
        const token = session.accessToken;
        if (token && !config.headers.Authorization) {
          config.headers.Authorization = `Bearer ${token}`;
        }

        let expirationDate = localUtils.getItem('REFRESH_INFO');
        if (expirationDate && expirationDate < new Date().getTime() && !isRefreshing) {
          refreshToken(http, session);
        }
      }
      //Loading
      if ((config && config.noLoading) || config.params) {
        let { noLoading } = config.params || config;
        if (noLoading) {
          requestAdded++;
          return config;
        }
      }
      addRequest();
      return config;
    },
    function (err) {
      subRequest();
      return Promise.reject(err);
    }
  );

  http.interceptors.response.use(
    function (response) {
      if (response && response.status == 401) {
        redirectToLogin();
      }
      subRequest();
      return response;
    },
    function (error) {
      subRequest();
      if (error && error.response) {
        switch (error.response.status) {
          case 401:
            redirectToLogin();
            break;
          case (400, 409):
            if (error.response.data.ExceptionType === 'SmarapdException' || 'SmarapdRaiserrorException') {
              _alert.warning(error.response.data.Message, 'Aviso');
            }
            error = error.response;
          default:
            !error.config.url.includes('fileManager/BrasaoWeb') && isShowException && _showError(error.response.data);
            break;
        }
      } else _showError(error);

      return Promise.reject(error);
    }
  );

  return http;
};
export default getHttp;
